import React from 'react';
import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';
import {
    SiteCard,
    SiteCardTitle,
    SiteCardSubTitle,
    SiteThumbnail,
    DescriptionTitle,
    DescriptionRow,
    DescriptionDetail,
    DescriptionDivisor,
} from './style';
import Button from '../Button';
import Enums from '../../../services/enums/sites';
import BasicImage from '../../../img/sites/basic@2x.png';
import PremiumImage from '../../../img/sites/premium@2x.png';
import ProImage from '../../../img/sites/pro@2x.png';

const basicTierOptions = [
    Enums.HOME,
    Enums.STOCK,
    Enums.FINANCING,
    Enums.COMPANY,
    Enums.CONTACT,
    Enums.BASIC_LAYOUT,
];

const premiumTierOptions = [
    Enums.HOME,
    Enums.STOCK,
    Enums.FINANCING,
    Enums.COMPANY,
    Enums.CONTACT,
    Enums.SERVICES,
    Enums.AFTER_SALES,
    Enums.TEST_DRIVE,
    Enums.CATALOG,
    Enums.OUR_STORES,
    Enums.PREMIUM_LAYOUT,
];

const proTierOptions = [
    Enums.HOME,
    Enums.STOCK,
    Enums.FINANCING,
    Enums.COMPANY,
    Enums.CONTACT,
    Enums.SERVICES,
    Enums.AFTER_SALES,
    Enums.TEST_DRIVE,
    Enums.CATALOG,
    Enums.OUR_STORES,
    Enums.PRO_LAYOUT,
];

const pageOptions = [
    Enums.HOME,
    Enums.STOCK,
    Enums.FINANCING,
    Enums.COMPANY,
    Enums.CONTACT,
    Enums.SERVICES,
    Enums.AFTER_SALES,
    Enums.TEST_DRIVE,
    Enums.CATALOG,
    Enums.OUR_STORES,
];

const layoutOptions = [
    Enums.BASIC_LAYOUT,
    Enums.PREMIUM_LAYOUT,
    Enums.PRO_LAYOUT,
];

const featureOptions = [
    Enums.SITE_BUILDER,
    Enums.NEW_PAGES,
    Enums.VIDEOS,
    Enums.SOCIAL_NETWORKS,
    Enums.WHATSAPP,
    Enums.DAILY_BACKUPS,
    Enums.RESPONSIVE_DESIGN,
    Enums.FEATURED_GALLERY,
    Enums.TAGS_MANAGER,
    Enums.MULTIPLE_DOMAINS,
];

const seoOptions = [
    Enums.SITEMAPS,
    Enums.META_DESCRIPTION,
    Enums.HTTPS_SSL,
];

const otherOptions = [
    Enums.SUPPORT,
    Enums.PREMIUM_HOST,
    Enums.GOOGLE_ANALYTICS,
    Enums.THIRD_PARTY,
];

const tierOptions = [
    { tier: Enums.BASIC, options: basicTierOptions },
    { tier: Enums.PREMIUM, options: premiumTierOptions },
    { tier: Enums.PRO, options: proTierOptions },
];

const solutionTargets = [
    { key: Enums.BASIC, data: 'Lojas pequenas e médias.' },
    { key: Enums.PREMIUM, data: 'Lojas médias e grandes.' },
    { key: Enums.PRO, data: 'Shoppings e Concessionárias.' },
];

const thumbnails = [
    { key: Enums.BASIC, image: BasicImage },
    { key: Enums.PREMIUM, image: PremiumImage },
    { key: Enums.PRO, image: ProImage },
];

const tierLinks = [
    { tier: Enums.BASIC, link: '/sites/basico' },
    { tier: Enums.PREMIUM, link: '/sites/personalizado' },
    { tier: Enums.PRO, link: '/sites/pro' },
];

function getTierSolution(tier) {
    return solutionTargets.find(value => value.key === tier).data;
}

function getTierThumbnail(tier) {
    return thumbnails.find(value => value.key === tier).image;
}

function getTierOptions(tier) {
    return tierOptions.find(value => value.tier === tier).options;
}

function getTierLink(tier) {
    return tierLinks.find(value => value.tier === tier).link;
}

const Description = ({ option, isActive }) => (
	<DescriptionRow>
		<div className="icon">
			{isActive && <FaCheck />}
		</div>
		<DescriptionDetail isActive={isActive}>{option}</DescriptionDetail>
	</DescriptionRow>
);

function renderDescriptionList(title, options, activeOptions, hasDivision = false) {
    return (
	<div style={{ padding: '0px 20px' }}>
		{ hasDivision && <div style={{ }} /> }
		<DescriptionTitle>{title}</DescriptionTitle>
		{options.map((option) => {
                const isActive = activeOptions.includes(option);
                return <Description option={option} isActive={isActive} />;
            })}
	</div>
    );
}

const SiteModelCard = ({ className, siteTier }) => (
	<SiteCard className={className}>
		<SiteCardTitle>Site <span>{siteTier}</span></SiteCardTitle>
		<SiteCardSubTitle>
			Solução ideal para<br />
			<span>{getTierSolution(siteTier)}</span>
		</SiteCardSubTitle>
		<SiteThumbnail>
			<img src={getTierThumbnail(siteTier)} alt={`site ${siteTier}`} />
		</SiteThumbnail>
		{ renderDescriptionList('Páginas', pageOptions, getTierOptions(siteTier)) }
		<DescriptionDivisor />
		{ renderDescriptionList('Layout', layoutOptions, getTierOptions(siteTier), true) }
		<DescriptionDivisor />
		{ renderDescriptionList('Funcionalidades', featureOptions, featureOptions, true) }
		<DescriptionDivisor />
		{ renderDescriptionList('SEO', seoOptions, seoOptions, true) }
		<DescriptionDivisor />
		{ renderDescriptionList('Outros', otherOptions, otherOptions, true) }
		<div
			style={{
                marginTop: '32px',
                marginBottom: '0',
                display: 'flex',
                justifyContent: 'center',
            }}
		>
			<div style={{
                width: '100%',
            }}
			>
				<Button
					type="link"
					fontSize="12px"
					borderRadius="8px"
					fontWeight="bold"
					margin="0"
					to={getTierLink(siteTier)}
				>
					Começar
				</Button>
			</div>
		</div>
	</SiteCard>
    );

SiteModelCard.defaultProps = {
    className: '',
    siteTier: Enums.BASIC,
};

PropTypes.SiteModelCard = {
    className: PropTypes.string,
    siteTier: PropTypes.string.isRequired,
};

export default SiteModelCard;
